export const SET_ACTIVE_BENCHMARK_LEGEND = 'SET_ACTIVE_BENCHMARK_LEGEND';

export const setActiveBenchmarkLegend = () => ({
  type: SET_ACTIVE_BENCHMARK_LEGEND,
});
